import * as React from "react";
import {observer} from "mobx-react";
import {withAppStores} from "../../../../../../../AppStores";
import {Field} from "../../../../../../widgets/form/field/Field";
import type {TransportLayer} from "../../../../../../../data/TransportLayer";
import {ClickToEditInput} from "../../../../../../widgets/input/clicktoedit/ClickToEditInput";
import {FieldDataType} from "../../../../../../../generated/api/base";
import type {AppState} from "../../../../../../../data/state/AppState";
import {featureTitles} from "../../../../../../../data/state/AppStateConstants";
import type {Report} from "../../../../../../../data/models/Report";
import {TimeUtils} from "../../../../../../../utils/TimeUtils";

interface IReportDefaultFieldsProps {
	readonly item: Report;
	readonly appState?: AppState;
	readonly transport?: TransportLayer;
}

interface IReportDefaultFieldsState {
	isUpdatingName: boolean;
	isUpdatingDescription: boolean;
}

@withAppStores("appState", "transport")
@observer
export class ReportDefaultFields extends React.Component<IReportDefaultFieldsProps, IReportDefaultFieldsState> {
	constructor(props: IReportDefaultFieldsProps) {
		super(props);
		this.state = {
			isUpdatingName: false,
			isUpdatingDescription: false,
		};
	}

	private onNameChange = async (value: string) => {
		const {item, transport} = this.props;

		item.name = value;

		this.setState({isUpdatingName: true});
		await TimeUtils.waitUpdate(transport.appState.actions.updateReport(item), this.props.appState.app.notificationContainer);
		this.setState({isUpdatingName: false});
	};

	private onDescriptionChange = async (value: string) => {
		const {item, transport} = this.props;

		item.description = value;

		this.setState({isUpdatingDescription: true});
		await TimeUtils.waitUpdate(transport.appState.actions.updateReport(item), this.props.appState.app.notificationContainer);
		this.setState({isUpdatingDescription: false});
	};

	public override render() {
		const {item, appState} = this.props;
		const {isUpdatingName, isUpdatingDescription} = this.state;

		return (
			<>
				<Field label={appState.actions.getRefIdName(item.ownFeature)}>{item.refId}</Field>
				<Field label="Name">
					<ClickToEditInput
						value={item.name}
						onChange={this.onNameChange}
						dataType={FieldDataType.SingleLineText}
						isUpdating={isUpdatingName}
						noButtons={true}
					/>
				</Field>
				<Field label="Category">{item.category}</Field>
				<Field label="Module">{featureTitles[item.reportFeature]}</Field>
				<Field label="Description">
					<ClickToEditInput
						dataType={FieldDataType.MultiLineText}
						onChange={this.onDescriptionChange}
						value={item.description}
						isUpdating={isUpdatingDescription}
					/>
				</Field>
			</>
		);
	}
}
